import React from 'react'
import gql from 'graphql-tag'
import {Mutation} from 'react-apollo'
import {notification} from 'antd'
import FormFields from './FormFields'

const chooseInputAssetsMutation = gql`
  mutation ChooseInputAssets($input: ChooseInputAssetsInput!, $productId: ID!) {
    ChooseInputAssets(input: $input) {
      product {
        id
      }
    }
    SubmitInput(productId: $productId) {
      product {
        id
        state
        requiresUserInput
        canProvideUserInput
      }
    }
  }
`

const descriptions = {
  DigitalRetouchedRenovationPhotoProduct: (
    <>
      <p>Her har du muligheten til å «pusse opp» utvalgte rom digitalt, og nå kan du selv velge hvilken stil du ønsker - eller - la desken velge dette for deg. Hvis du ønsker at vår desk skal velge stil og farger, velger du bildet(ne) som skal pusses opp og trykker "Send til redigering".</p>
      <p>Merk: Du avgjør selv om du ønsker å forandre veggfarge eller gulvtype. Om du er fornøyd med veggfargen, men vil endre gulvet, så kan du gjøre det.</p>
      <p>Sånn velger du selv farger, gulvtype og møbelsett:</p>
      <ol>
        <li>Trykk på knappen "STILALTERNATIVER". Den tar deg til stil-biblioteket.</li>
        <li>Veggfarge: gå inn på "dekorasjoner og gulvmateriale", velg "veggfarger" og legg fargenummer (feks #11) inn i feltet som heter "veggkode".</li>
        <li>Gulvmateriale: følg pkt 2, velg "Gulv" og legg inn gulvkode (feks WL2) inn i feltet som heter "gulvkode".</li>
        <li>
          Møbelsett: velg møbelsettet du ønsker og legg det inn i feltet som heter "møbelkode".<br />
          PS! Hvis du trykker på møbelsettet, kan du kopiere koden derfra.
        </li>
        <li>Trykk "send til redigering"</li>
      </ol>
      <p>Digital oppussing har 24-timers produksjonstid fra bestillingstidspunkt (arbeidsdager).</p>
    </>
  ),

  DigitalRetouchedFurnishingPhotoProduct: (
    <>
      <p>Nå har du muligheten til å velge møblement for rommet du ønsker å møblere. Om du ønsker at vår desk skal velge møbelsett, velger du bildet(ne) som skal møbleres og trykker "Send til redigering".</p>
      <p>Sånn velger du møbelsett selv:</p>
      <ol>
        <li>Trykk på knappen "STILALTERNATIVER". Den tar deg til stil-biblioteket.</li>
        <li>
          Velg møbelsettet du ønsker (feks 2134) og legg det inn i feltet som heter "møbelkode".<br />
          PS! Hvis du trykker på møbelsettet, kan du kopiere koden derfra.
        </li>
        <li>Trykk "send til redigering".</li>
      </ol>
      <p>Digital oppussing har 24-timers produksjonstid fra bestillingstidspunkt (arbeidsdager).</p>
    </>
  ),
}

const ConfirmPhotos = ({product, selectedPhotos, setStep}) => {
  const description = descriptions[product.__typename] || null

  return (
    <div className="retouched-photo-product provide-input confirm-photos">
      {!!description && (
        <div className="description">
          {description}
        </div>
      )}

      <Mutation
        mutation={chooseInputAssetsMutation}
        onCompleted={() => {
          notification['success']({
            message: 'Sendt til redigering',
            description: 'Bildene er nå sendt til redigering.',
          })
        }}
        onError={() => {
          notification['error']({
            message: 'Innsending feilet',
            description: 'Bildene kunne ikke sendes inn grunnet en feil. Forsøk på nytt senere.',
          })
        }}
      >
        {(chooseInputAssets, {loading}) => (
          <FormFields
            product={product}
            isSubmitting={loading}
            photos={selectedPhotos}
            onCancel={() => setStep('select')}
            onSubmit={(data) => {
              chooseInputAssets({
                variables: {
                  productId: product.id,
                  input: {
                    productId: product.id,
                    assets: Object.keys(data).map((id) => ({
                      assetId: id,
                      metadata: {editingThemes: data[id]},
                    }))
                  }
                }
              })
            }}
          />
        )}
      </Mutation>
    </div>
  )
}

export default ConfirmPhotos
